import React, { FC } from "react"

import { useMantineTheme } from "@mantine/core"
import LatLngBounds = google.maps.LatLngBounds
import MapMouseEvent = google.maps.MapMouseEvent
import MapsEventListener = google.maps.MapsEventListener

import alphabet from "../../assets/alphabet"
import { GoogleMaps, GoogleMapsProps } from "../../../../services/google-maps"
import { Marker } from "@vis.gl/react-google-maps"

let MapsListener: MapsEventListener | undefined

type DeviceMapProps = GoogleMapsProps & {
    onClick?: (lat: number, lang: number) => void
    readOnly?: boolean
    markers: {
        label: string
        latitude: number
        longitude: number
        onClick?: () => void
    }[]
}

const DeviceMap: FC<DeviceMapProps> = ({ markers, onClick, readOnly = true, ...props }) => {
    const theme = useMantineTheme()

    const runWith = (map: google.maps.Map) => {
        if (map) {
            if (markers.length > 0) {
                map.fitBounds(
                    markers.reduce<LatLngBounds>(
                        (acc, curr) =>
                            acc.extend({
                                lat: curr.latitude,
                                lng: curr.longitude,
                            }),
                        new window.google.maps.LatLngBounds(),
                    ),
                    16,
                )
            } else {
                map.setCenter({ lat: 52.083843, lng: 5.834269 })
            }

            const minZoom = 8
            const maxZoom = 15
            const zoom = map.getZoom() ?? minZoom

            MapsListener?.remove()
            if (onClick != null) {
                MapsListener = map.addListener("click", (event: MapMouseEvent) => {
                    if (event.latLng && !readOnly) onClick(event.latLng.lat(), event.latLng.lng())
                })
            }

            map.setZoom(zoom > maxZoom ? maxZoom : zoom)
        }
    }

    return (
        <GoogleMaps runWith={runWith} {...props}>
            {markers.map(({ label, latitude, longitude, onClick }, index) => (
                <Marker
                    key={index}
                    position={{
                        lat: latitude,
                        lng: longitude,
                    }}
                    label={{
                        text: alphabet[index % alphabet.length],
                        color: theme.white,
                        fontFamily: theme.fontFamily,
                    }}
                    title={label}
                    clickable={onClick !== undefined}
                    onClick={onClick}
                />
            ))}
        </GoogleMaps>
    )
}

export default DeviceMap
